import React, { useEffect } from 'react'
import {
  Grid,
  TextField,
  MenuItem,
  FormHelperText,
  Card,
  CardContent
} from '@material-ui/core'
import { Controller } from 'react-hook-form'

const InputContacts = (props: any) => {
  const { errors, watch, control, setValue } = props.form
  const { contactsCourier, setContactId } = props

  const customerName = watch('customerName')

  useEffect(() => {
    if (customerName) {
      const contact = contactsCourier.find(
        (item: any) => item.fullName === customerName
      )
      setContactId(contact?.specialContactId)
    }
  }, [customerName])

  useEffect(() => {
    const exists = contactsCourier.some(
      (item: any) => item.fullName === customerName
    )
    !exists && setValue('customerName', '')
  }, [contactsCourier])

  return (
    <Card style={{ marginBottom: '20px' }}>
      <CardContent style={{ padding: '12px !important' }}>
        <Grid item lg alignItems='flex-end'>
          <div
            style={{ marginTop: '24px', marginBottom: '24px', width: '300px' }}
          >
            <div style={{ width: '100%' }} data-cy='customerName'>
              <Controller
                style={{ width: '100%' }}
                control={control}
                rules={{ required: true }}
                name='customerName'
                id='customerName'
                label='انبار مقصد'
                as={
                  <TextField
                    type='search'
                    variant='outlined'
                    select
                    fullWidth
                    InputLabelProps={{
                      shrink: customerName
                    }}
                    error={errors.customerName && true}
                  >
                    {contactsCourier.map((item: any) => (
                      <MenuItem
                        key={item.id}
                        data-cy={item.id}
                        value={item.fullName}
                        id={item.fullName}
                      >
                        {item.fullName}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors?.customerName && 'نوع انبار مقصد الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default InputContacts
